import { render, staticRenderFns } from "./DailyGift.vue?vue&type=template&id=87a80986"
import script from "./DailyGift.vue?vue&type=script&lang=js"
export * from "./DailyGift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports